import { render, staticRenderFns } from "./ChatDetails.vue?vue&type=template&id=5028dce2&"
import script from "./ChatDetails.vue?vue&type=script&lang=js&"
export * from "./ChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports